export enum WaterInstallationTypeEnum {
  Linear = 'linear_installation',
  Ring = 'ring_installation',
  Tee = 'tee_installation',
}
